var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabReportThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lab-report-thumb",
    transform: "translate(-104 -373)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 48,
    height: 48,
    rx: 8,
    transform: "translate(104 373)",
    fill: "#f5fbfc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "folder-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1028",
    "data-name": "Rectangle 1028",
    width: 24,
    height: 24,
    transform: "translate(116 385)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4050",
    "data-name": "Path 4050",
    d: "M12.414,5H21a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3h7.414ZM8,19H20V11H8ZM6,19V10A1,1,0,0,1,7,9H20V7H11.586l-2-2H4V19Z",
    transform: "translate(116 385)",
    fill: "#09c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabReportThumb);
export default __webpack_public_path__ + "static/media/lab-report-thumb.17fba7176604c77e1ea15d677bb7c3c4.svg";
export { ForwardRef as ReactComponent };